var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pro_enc_input"
  }, [_vm.loading ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm.disabled ? _c('ProEncInputShow', {
    attrs: {
      "decodeValue": _vm.decodeValue,
      "encodeValue": _vm.encodeValue
    }
  }) : _c('ProEncInputEdit', _vm._b({
    attrs: {
      "value": _vm.value
    },
    on: {
      "onChange": _vm.onChange
    }
  }, 'ProEncInputEdit', _vm.$attrs, false))], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };